import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { hasIn } from 'lodash';
import { CookieService, DefaultConst, JwtService } from 'src/app/core';

@Component({
  selector: 'app-sisense-metrics',
  templateUrl: './sisense-metrics.component.html',
  styleUrls: ['./sisense-metrics.component.less'],
})
export class SisenseMetricsComponent implements OnInit, OnDestroy {
  private _iFrameUrl: SafeResourceUrl;
  COOKIE_NAME = DefaultConst.SISENSE_JWT_COOKIE_NAME;
  url: string;

  @ViewChild('sisenseIFrame') sisenseIFrame?: ElementRef<HTMLInputElement>;
  @Input() isAdmin;
  @Input() iFrameUrl;

  constructor(
    private domSanitzer: DomSanitizer,
    private jwtService: JwtService,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.addCookie();
    this.url = this.buildIframeUrl(this.iFrameUrl) as string;
  }

  ngAfterViewInit(): void {
    this.sisenseIFrame.nativeElement.style.height = '990px';
  }

  buildIframeUrl(iFrameUrl): SafeResourceUrl {
    return this.domSanitzer.bypassSecurityTrustResourceUrl(
      `${iFrameUrl}?embed=true&r=${this.isAdmin}`
    );
  }

  addCookie() {
    const jwt = this.jwtService.getToken();
    this.cookieService.saveCookie(this.COOKIE_NAME, jwt);
  }

  ngOnDestroy() {
    this.cookieService.destroyCookie(this.COOKIE_NAME);
  }
}
